export default __webpack_public_path__ + "static/media/logo-horisontal.87bfc628.svg";